const APP_NAME = "next-year";

const STRIPE_PRODUCTS = {
  subscriptions: {},
  products: {
    MixQuickEarlyAccess: {
      name: "MixQuickEarlyAccess",
      friendlyName: "Mix.Quick Early Access",
      productId: "prod_SQIHS2Id3X89zb",
      priceUSDCents: 40_00,
    },
  },
};

const STRIPE_PRODUCT_ID_MAP = Object.values((priceObj) => [
  priceObj.productId,
  priceObj,
]);

export { APP_NAME, STRIPE_PRODUCTS, STRIPE_PRODUCT_ID_MAP };
